import React from 'react';

import SubtopSolution from '@/components/apps/ui/subtop/SubtopSolution';
import TransCustom from '@/components/apps/ui/transCustom/TransCustom';

import SolutionArchitectureSection from '../shared/architecture/SolutionArchitectureSection';
import SolutionMachineDetectionSection from './SolutionMachineDetectionSection';
import { SolutionMachineExSection } from './SolutionMachineExSection';
import SolutionMachineKeySection from './SolutionMachineKeySection';
import IndustrialEvidenceSection from './section/IndustrialEvidenceSection';
import IndustrialFaqSection from './section/IndustrialFaqSection';
import IndustrialFasteningSection from './section/IndustrialFasteningSection';
import IndustrialPocCtaSection from './section/IndustrialPocCtaSection';
import IndustrialSoundSection from './section/IndustrialSoundSection';
import IndustrialSystemSection from './section/IndustrialSystemSection';

export default function SolutionMachine() {
  return (
    <div className="flex flex-col bg-apps-brandGrayBlack pb-[100px] text-apps-coreGrayWhite lg:pb-[clamp(100px,16.667vw,200px)]">
      <SubtopSolution
        kind="industrial"
        subtitle={
          <TransCustom i18nKey="기계에서 발생하는 소리, 품질데이터로 전환" />
        }
        subtitleClassName="text-apps-corePrimary01"
        title={
          <TransCustom i18nKey="기계 장비 이상을 탐지하는 Listen AI 머신 솔루션" />
        }
        desktopImage={{
          src: '/images/apps/solution/industrial/SubtopSolution_img_02.png',
          width: 1480,
          height: 806,
        }}
        mobileImage={{
          src: '/images/apps/solution/industrial/SubtopSolution_img_02_m.png',
          width: 1005,
          height: 552,
        }}
        imageAlt="Listen AI 머신 솔루션"
      />

      {/* 3대 양산 유즈케이스 */}
      <SolutionMachineKeySection />

      {/* 3대 양산 지표 */}
      <IndustrialEvidenceSection />

      {/* 체결 검사 심화 (위 두 섹션의 하위 블록) */}
      <IndustrialFasteningSection />

      {/* 감지 가능한 주요 사운드 */}
      <IndustrialSoundSection />

      {/* 실시간모니터링 */}
      <IndustrialSystemSection />

      {/* 온프렘 구성 방식 */}
      <SolutionArchitectureSection variant="onprem" idPrefix="industrial" />

      {/* 평소와 다른 */}
      <SolutionMachineDetectionSection />

      {/* 적용 예시 */}
      <SolutionMachineExSection />

      {/* 자주 묻는 질문 */}
      <IndustrialFaqSection />

      {/* PoC 문의 */}
      <IndustrialPocCtaSection />
    </div>
  );
}
